module.exports = __webpack_public_path__ + "img/node.2d387058.svg";